//#region src/variants/variants_mode_island.js
var variants_mode_island_default = {
	default: { slots: { default: { initialValue: "<dt-text as=\"p\">Inverted mode (opposite of parent)</dt-text>" } } },
	light: {
		props: { mode: { initialValue: "light" } },
		slots: { default: { initialValue: "<dt-text as=\"p\">Always light mode</dt-text>" } }
	},
	dark: {
		props: { mode: { initialValue: "dark" } },
		slots: { default: { initialValue: "<dt-text as=\"p\">Always dark mode</dt-text>" } }
	}
};
//#endregion
export { variants_mode_island_default as default };

//# sourceMappingURL=variants_mode_island.js.map